import gql from 'graphql-tag';

export default gql`
fragment OrderUpdateLogOriginal on OrderUpdateLogData {
    synchronized
    total_amount
    shipping_cost
    timetable_time_slot {
        sector {
            name
        }
        range_date
        timeRange {
            time_from
            time_to
        }
    }
    post_point {
        id
    }
    shipping_method {
        id
    }
    payment_method {
        id
    }
    linked_order {
        id
    }
    comment
    status {
        title
    }
    is_admin_checked
    admin_id
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/fragments/OrderUpdateLogOriginal.ts